import React from 'react';
import { useStyles } from './styles';
import { Box, Typography, Dialog, Grid, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PhoneIcon from '@material-ui/icons/Phone';
import InfoIcon from '@material-ui/icons/Info';
import moment from 'moment';

export const ServiceTransferAlert = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
  
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.closeServiceTransferPopup} open={true}>
      <IconButton onClick={props.closeServiceTransferPopup} className={classes.closeIcon}>
        <CancelIcon />
      </IconButton>
      <Box className={classes.root}>
        
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Service Transfer Restriction</Typography>
        </Box>

        <Box className={classes.newServicer}>
          <Grid container direction="row" alignItems="center" style={{ paddingLeft: '5px' }}>
            <Grid item md={12} xs={12} lg={12}>
              <Box display='flex' alignItems="center">
                {/* <InfoIcon className={classes.paidInFullIcon} /> */}
                <Typography className={classes.information}>The selected payment date is not allowed because this loan is scheduled to be transferred to a new servicer on <b>{moment(props.transferData.newServicerDate).format('ll')}</b>. Please select a payment date before the transfer date.</Typography>
              </Box>
              {props?.show &&
              <Box pt={2} >
                <Typography className={classes.informationText}>Below is the details on your new servicer: </Typography>
                <Typography className={classes.informationText}>New Servicer: <span className={classes.servicerText}> {props?.transferData.newServicerName}</span></Typography>
                {((props?.transferData.newServicerPhone !== null) && (props?.transferData.newServicerPhone !== 'null')) &&
                  <Box style={{display: 'flex', alignItems: 'center'}}>
                  <Typography className={classes.callUs}>If you need help or have questions, please don't hesitate to call your new servicer at
                  <PhoneIcon mr={2} className={classes.iconStyle} />
                    <a href={"tel:" + props?.transferData.newServicerPhone} style={{textDecoration: 'none', cursor: 'pointer'}}> <span className={`${classes.contactTime} ${classes.noUnderLine}`} >{props?.transferData.newServicerPhone}</span></a></Typography>
                    </Box>
                  }
              </Box>}
            </Grid>
          </Grid>
        </Box>

         <Box className={classes.cardFooter}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={() => props.closeServiceTransferPopup()}
              >OK</Button>
          </Box>
      </Box> 
   </Dialog>
  )
}